/**
 * CrisisAlert — inline crisis resources shown when crisis signals are detected
 * in user-written text during a session phase.
 *
 * Does NOT block the user from continuing — it provides resources
 * while leaving the session open. Shown once per phase and stays
 * visible for the remainder of that phase.
 *
 * The helplines come from the locale, never hardcoded. This component
 * previously listed the US lines only (988, Crisis Text Line), which meant a
 * Polish user in crisis was handed numbers that do not work where they are.
 * crisis.resources carries the Polish lines Marta verified.
 */
import { useTranslation } from 'react-i18next'

export default function CrisisAlert() {
  const { t } = useTranslation()
  // One helpline per line in the locale value — split so each keeps its own row
  // regardless of how many a given locale lists.
  const lines = t('crisis.resources').split('\n').filter(Boolean)

  return (
    <div
      role="alert"
      style={{
        background: '#FFF5F5',
        border: '1.5px solid #FCA5A5',
        borderRadius: '0.875rem',
        padding: '1rem 1.25rem',
        marginTop: '0.875rem',
      }}
    >
      <p style={{ fontSize: '0.875rem', color: '#991B1B', fontWeight: 600, margin: '0 0 0.375rem' }}>
        {t('crisis.heading')}
      </p>
      <div style={{ fontSize: '0.8125rem', color: '#7F1D1D', lineHeight: 1.65 }}>
        {lines.map((line, i) => <p key={i} style={{ margin: 0 }}>{line}</p>)}
      </div>
    </div>
  )
}
